import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import axios from 'axios'
import { api } from '../../utils/api'
import { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { getFromStorage } from '../../utils/storage'
import { handleError } from '../../utils/error'
import { Card, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../../redux/store'
import { mainGreen } from '../../utils/color'

export default function SignUpUser() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const [roles, setRoles] = useState([])
	const [stores, setStores] = useState([])
	const [storeId, setStoreId] = useState('')
	const [showStore, setShowStore] = useState(false)
	const [roleId, setRoleId] = useState('')
	const [signUpData, setSignUpData] = useState({
		values: {
			name: '',
			email: '',
		},
		errors: {
			name: '',
			email: '',
		},
	})

	const getRoles = useCallback(
		async function () {
			try {
				const response = await axios({
					url: currentUser.role === 'admin' ? api.GET_ROLES_ADMIN : api.GET_ROLES_DIRECTOR,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoles(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, currentUser.role, navigate, dispatch],
	)

	useEffect(() => {
		getRoles()
	}, [getRoles])

	const getStores = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_STORES_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStores(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token],
	)

	useEffect(() => {
		getStores()
	}, [getStores])

	const handleChangeSelectRole = (event) => {
		if (
			event.target.value !== '643cef2e162c633b558c08cd' &&
			event.target.value !== '643ce869e6c312b8c449e26f' &&
			event.target.value !== '643eaa0fd418d1fe9aefd4a7'
		) {
			setShowStore(true)
		} else {
			setShowStore(false)
		}
		setRoleId(event.target.value)
	}

	const handleChangeSelectStore = (event) => {
		setStoreId(event.target.value)
	}

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...signUpData.values, [name]: value }
		let newError = { ...signUpData.errors }

		if (name === 'name')
			if (value.trim() === '') {
				newError[name] = '* Tên tài khoản không được để trống!'
			} else {
				newError[name] = ''
			}

		if (name === 'email') {
			const regexEmail =
				/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
			if (!regexEmail.test(value) && value.length > 0) {
				newError[name] = '* Email không hợp lệ!'
			} else if (value.trim() === '') {
				newError[name] = '* Email không được để trống!'
			} else {
				newError[name] = ''
			}
		}

		setSignUpData({ values: newValue, errors: newError })
	}

	const registerUser = async function (data) {
		try {
			const response = await axios({
				method: 'POST',
				url: api.SIGNUP_USER_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data,
			})
			alert(response.data.message)
		} catch (error) {
			alert(error.response.data.message)
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault()

		if (
			signUpData.errors.email !== '' ||
			signUpData.errors.name !== '' ||
			roleId === '' ||
			(showStore && storeId === '')
		) {
			alert('Vui lòng điền đầy đủ thông tin')
			return
		}

		const name = signUpData.values.name
		const email = signUpData.values.email

		const registerData = {
			name,
			email,
			roleId,
			storeId,
		}
		registerUser(registerData)
		navigate('/admin/users')
	}

	return (
		<UserLayout>
			<Container sx={{ marginTop: '20px' }} maxWidth='sm'>
				<CssBaseline />
				<Card sx={{ padding: '10px' }}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}>
						<Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
							{signUpData.errors.name === '' ? (
								<TextField
									sx={{ background: '#fff' }}
									margin='normal'
									required
									fullWidth
									id='name'
									label='Tên tài khoản'
									name='name'
									autoComplete='name'
									autoFocus
									onChange={handleChange}
								/>
							) : (
								<TextField
									sx={{ background: '#fff' }}
									error
									margin='normal'
									required
									fullWidth
									id='name'
									label='Tên tài khoản'
									name='name'
									autoComplete='name'
									autoFocus
									onChange={handleChange}
								/>
							)}
							<Typography sx={{ color: '#ff0000' }}>{signUpData.errors.name}</Typography>
							{signUpData.errors.email === '' ? (
								<TextField
									sx={{ background: '#fff' }}
									margin='normal'
									required
									fullWidth
									id='email'
									label='Email'
									name='email'
									autoComplete='email'
									autoFocus
									onChange={handleChange}
								/>
							) : (
								<TextField
									sx={{ background: '#fff' }}
									margin='normal'
									error
									required
									fullWidth
									id='email'
									label='Email'
									name='email'
									autoComplete='email'
									autoFocus
									onChange={handleChange}
								/>
							)}
							<Typography sx={{ color: '#ff0000' }}>{signUpData.errors.email}</Typography>

							<FormControl sx={{ mt: 2, mr: 2, minWidth: 120 }} size='small'>
								<InputLabel id='role-select-small-label'>Vị trí</InputLabel>
								<Select
									required
									labelId='role-select-small-label'
									id='demo-select-small'
									label='Vị trí'
									value={roleId}
									onChange={handleChangeSelectRole}>
									{roles?.map((role, index) => {
										return (
											<MenuItem key={index} value={role._id}>
												{role.description}
											</MenuItem>
										)
									})}
								</Select>
							</FormControl>
							{showStore && (
								<FormControl sx={{ mt: 2, minWidth: 120 }} size='small'>
									<InputLabel id='role-select-small-label'>Cửa hàng</InputLabel>
									<Select
										required
										labelId='role-select-small-label'
										id='demo-select-small'
										label='Cửa hàng'
										value={storeId}
										onChange={handleChangeSelectStore}>
										{stores?.map((store, index) => {
											return (
												<MenuItem key={index} value={store._id}>
													{store.name}
												</MenuItem>
											)
										})}
									</Select>
								</FormControl>
							)}

							<Button
								type='submit'
								fullWidth
								variant='contained'
								sx={{
									mt: 3,
									mb: 2,
									background: mainGreen,
									'&:hover': { background: mainGreen },
								}}>
								Đăng ký
							</Button>
						</Box>
					</Box>
				</Card>
			</Container>
		</UserLayout>
	)
}
